import {connect} from "react-redux"
import React, {Component} from "react"
import styled from "styled-components"
import blueBackArrow from "manager/../images/blue-back-arrow.svg"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"

const IconBackContainer = styled(SettlementMaxWidth)`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  background-color: white;
  margin: 0;
  padding-left: 15px;
  padding-top: 13px;
  
  @media screen and ${DESKTOP_BREAKPOINT} {
    padding-top: 16px;
    background-color: transparent;
  }

`
const BackIcon = styled.div`
  background-image: url(${blueBackArrow});
  height: 9.59px;
  width: 6.16px;
  flex: 0 0 6.16px;
`
const BackA = styled.a`
  margin-left: 7px;
`

class BackLink extends Component {

  render() {
    return (
      <IconBackContainer>
        <BackIcon/>
        <BackA onClick={this.props.onClick}>Back</BackA>
      </IconBackContainer>
    )
  }

}

export default connect(null, null)(BackLink)
